// BlockNote schema for the Playbook editor — FE-044.
//
// Bundles the default block specs (paragraph, heading, list, etc.)
// alongside the custom Commitment block so the FE-045 editor can
// instantiate ``useCreateBlockNote({ schema })`` against a typed
// schema that includes ``commitment`` as a known type.
//
// FE-044 ships the schema definition only — the editor surface
// itself is FE-045. Materialization on the backend reads the
// resulting ``blocks_json`` so the on-disk shape needs to be
// settled now.

import { BlockNoteSchema, defaultBlockSpecs } from "@blocknote/core";

import {
  COMMITMENT_BLOCK_TYPE,
  commitmentBlockSpec,
} from "./CommitmentBlock";


export const playbookBlockSpecs = {
  ...defaultBlockSpecs,
  [COMMITMENT_BLOCK_TYPE]: commitmentBlockSpec,
} as const;


export const playbookSchema = BlockNoteSchema.create({
  blockSpecs: playbookBlockSpecs,
});


export { COMMITMENT_BLOCK_TYPE, commitmentBlockSpec };
